// extracted by mini-css-extract-plugin
export default {"container":"styles_container__6Z1Qs","pills":"styles_pills__4XmyQ","pill":"styles_pill__9v9Mw"};